export default __webpack_public_path__ + "static/Appeal-Pages-1-fc04b0053ae64f819eeceb9fe39c6a70.jpg";